"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Discussions = void 0;
const types_1 = require("@air/types");
const querystring_1 = require("querystring");
const request_1 = require("./request");
const util_1 = require("./util");
function create(input, shortId) {
    const baseRequestInput = {
        method: 'POST',
        body: input,
        boardContext: input.discussion.boardId,
    };
    const requestInput = shortId
        ? (0, util_1.addShortUrlRequestData)(baseRequestInput, shortId)
        : baseRequestInput;
    return (0, request_1.airRequest)(types_1.EndpointType.discussions, requestInput);
}
function list(input, shortId) {
    return __awaiter(this, void 0, void 0, function* () {
        const pageDefaults = {
            discussionLimit: 100,
            commentLimit: 100,
            cursor: '',
        };
        const baseRequestInput = {
            method: 'GET',
            endpoint: `?${(0, querystring_1.stringify)(Object.assign(Object.assign({}, pageDefaults), input))}`,
            boardContext: input.boardId,
        };
        const requestInput = shortId
            ? (0, util_1.addShortUrlRequestData)(baseRequestInput, shortId, {
                authorized: 'optional',
            })
            : baseRequestInput;
        return (0, request_1.airRequest)(types_1.EndpointType.discussions, requestInput);
    });
}
function reply(_a) {
    return __awaiter(this, arguments, void 0, function* ({ comment, boardId, shortId, }) {
        const baseRequestInput = {
            method: 'POST',
            endpoint: 'reply',
            body: comment,
            boardContext: boardId,
        };
        const requestInput = shortId
            ? (0, util_1.addShortUrlRequestData)(baseRequestInput, shortId)
            : baseRequestInput;
        return (0, request_1.airRequest)(types_1.EndpointType.discussions, requestInput);
    });
}
function deleteComment(_a) {
    return __awaiter(this, arguments, void 0, function* ({ commentId, boardId, shortId, }) {
        const body = { commentId };
        const baseRequestInput = {
            method: 'DELETE',
            body,
            endpoint: 'comment',
            boardContext: boardId,
        };
        const requestInput = shortId
            ? (0, util_1.addShortUrlRequestData)(baseRequestInput, shortId)
            : baseRequestInput;
        return (0, request_1.airRequest)(types_1.EndpointType.discussions, requestInput);
    });
}
function update(_a) {
    return __awaiter(this, arguments, void 0, function* ({ input, boardId, shortId, }) {
        const baseRequestInput = {
            method: 'PATCH',
            body: input,
            boardContext: boardId,
        };
        const requestInput = shortId
            ? (0, util_1.addShortUrlRequestData)(baseRequestInput, shortId)
            : baseRequestInput;
        return (0, request_1.airRequest)(types_1.EndpointType.discussions, requestInput);
    });
}
function updateComment(_a) {
    return __awaiter(this, arguments, void 0, function* ({ input, boardId, shortId, }) {
        const baseRequestInput = {
            method: 'PATCH',
            body: input,
            endpoint: 'comments',
            boardContext: boardId,
        };
        const requestInput = shortId
            ? (0, util_1.addShortUrlRequestData)(baseRequestInput, shortId)
            : baseRequestInput;
        return (0, request_1.airRequest)(types_1.EndpointType.discussions, requestInput);
    });
}
exports.Discussions = {
    create,
    list,
    reply,
    deleteComment,
    update,
    updateComment,
};
//# sourceMappingURL=discussions.js.map